import { createRoute } from '@tanstack/react-router';
import { authedChromeRoute } from '../layouts';

/**
 * The `/:siteId/staff` tree is staff-only. `authedRoute` reads `staffOnly` off the matched routes
 * and turns anyone else away before a site is loaded, so a non-staff visitor to another site's
 * `/staff` never switches the session onto that site.
 *
 * Pathless parent shared by the staff family's own leaves (staff/index.tsx) and its Billing/Team
 * sub-groups. Under `authedChromeRoute` for the sidebar/layout shell.
 */
export const staffRoute = createRoute({
  getParentRoute: () => authedChromeRoute,
  id: '_staff',
  staticData: { staffOnly: true },
});
